module.exports = __webpack_public_path__ + "media/src/assets/images/lps-trip-ee00ea599ff7748952389c32ef20d3b7.png";